import { useCallback } from 'react';
import { useKey } from 'rooks';

import useVideoPlayerStore from 'components/video-player-dubbing/store';

const allowDefaultAction = handler => (event: KeyboardEvent) => {
  if (event.target === document.body) {
    event.preventDefault();
    handler();
  }
};

export const useKeyboardControls = ({ player }) => {
  const {
    playbackMode,
    roundedTime: currentTime,
    requestCurrentTime
  } = useVideoPlayerStore(state => ({
    ...state
  }));

  const playing = playbackMode === 'playing';

  const togglePlay = useCallback(() => {
    if (playing) player.pause();
    else player.play();
  }, [playing, player]);

  const seekForward = useCallback(() => {
    requestCurrentTime(currentTime + 5);
  }, [currentTime, requestCurrentTime]);

  const seekBackward = useCallback(() => {
    requestCurrentTime(currentTime - 5);
  }, [currentTime, requestCurrentTime]);

  useKey(['Space'], allowDefaultAction(togglePlay));
  useKey(['ArrowRight'], allowDefaultAction(seekForward));
  useKey(['ArrowLeft'], allowDefaultAction(seekBackward));

  return {
    togglePlay
  };
};
